import Box, { BoxProps } from '@mui/material/Box';
import React, { useCallback } from 'react';

import { useAnnouncements } from '@/contexts/announcements/Announcements.context.tsx';

type Props = BoxProps & {
  anchorKey: string;
};

export const AnnouncementAnchor: React.FC<Props> = ({ anchorKey, children, ...rest }) => {
  const { registerAnchor, unregisterAnchor } = useAnnouncements();

  const handleRef = useCallback(
    (node: HTMLElement | null) => {
      if (node) {
        registerAnchor(anchorKey, node);
        return;
      }

      unregisterAnchor(anchorKey);
    },
    [anchorKey, registerAnchor, unregisterAnchor],
  );

  return (
    <Box ref={handleRef} {...rest}>
      {children}
    </Box>
  );
};
